import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';

//react
import React from 'react';
//material ui
import Button from '@material-ui/core/Button';
//JSzip
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'file-saver';

let Deferred = function () {
  this.promise = new Promise(
    function (resolve, reject) {
      this.resolve = resolve;
      this.reject = reject;
    }.bind(this)
  );

  this.then = this.promise.then.bind(this.promise);
  this.catch = this.promise.catch.bind(this.promise);
};

export class MyIconsDownload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...subCategoryStore.getState(),
    };
    subCategoryStore.subscribe(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    this.setState({
      ...subCategoryStore.getState(),
    });
  }
  downloadMyIcons() {
    let zip = new JSZip();

    let deferredAddZip = (filename, url, zip) => {
      let defer = new Deferred();

      JSZipUtils.getBinaryContent(url, function (err, data, log) {
        zip.file(filename, data, { binary: true });
        // console.log('done', url, data);
        defer.resolve(data);
      });

      return defer;
    };

    let deferreds = [];

    let myIcons = subCategoryStore.getState().myIcons;
    for (let i = 0; i < myIcons.length; i++) {
      gtag('event', 'My Icons Download', {
        event_category: 'Download',
        event_label: myIcons[i].path,
      });

      const path = myIcons[i].path;
      const exention = path.substring(path.length - 4);
      deferreds.push(
        deferredAddZip(
          myIcons[i].id + exention,
          'https:' +
            subCategoryStore.getState().symbologyJson.meta.s3_root_url +
            myIcons[i].path,
          zip
        )
      );
    }

    Promise.all(deferreds).then(
      function (results) {
        zip.generateAsync({ type: 'blob' }).then(
          function (blob) {
            // 1) generate the zip file
            saveAs(blob, 'icons.zip'); // 2) trigger the download
          },
          function (err) {
            jQuery('#blob').text(err);
          }
        );

        const obj = { isAdd: false, item: null };
        subCategoryActions.updateMyIcons(obj);
      },
      function (err) {
        console.log(err);
      }
    );
  }

  render() {
    return (
      <div className='my-icons'>
        <Button
          variant='contained'
          secondary='true'
          onClick={this.downloadMyIcons.bind(this)}
          className='my-icons-button'
        >
          My Icons ( {this.state.myIcons.length} )
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/toolbar/myIcons.js